export const wait = async (delay, callback) => await new Promise((resolve) => window.setTimeout(callback, delay));
//# sourceMappingURL=utils.js.map